import * as categories from 'utils/gdpr/categories';
import { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, PERFORMANCE, SOCIAL } from 'utils/gdpr/constants';

const dict = {
	'1': STRICTLY_NECESSARY,
	'2': PERFORMANCE,
	'3': FUNCTIONAL,
	'4': TARGETING,
	'5': SOCIAL,
	'8': SOCIAL,
	'C0001': STRICTLY_NECESSARY,
	'C0002': PERFORMANCE,
	'C0003': FUNCTIONAL,
	'C0004': TARGETING,
	'C0005': SOCIAL,
	'C0007': PERFORMANCE,
	'C0008': SOCIAL,
	'BG551': STRICTLY_NECESSARY,
	// 'BG552': PERFORMANCE,
	// 'BG554': TARGETING,
	'pc': PERFORMANCE,
	'tc': TARGETING,
	'tpv': 'SALE'
};

export const set = (ids) => {
	// client's weird set up - performance cookies should only drop if both pc and tpv are set
	const newCats = (Array.isArray(ids) ? ids : ids.split(',')).map(id => dict[id]).filter((a) => {
		if (a === PERFORMANCE && !ids.includes('tpv')) {
			return false;
		}
		if (a === dict.tpv) {
			return false;
		}
		return !!a;
	});
	categories.set(newCats);
};


